import pdfMake from 'pdfmake/build/pdfmake';

if (pdfMake.vfs === undefined) {
    let pdfFonts = require('pdfmake/build/vfs_fonts.js');
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
        KhmerOs: {
            normal: 'KhmerOs.ttf',
            bold: 'KhmerOsMoul.ttf',
        },
        Hanuman: {
            normal: 'Hanuman.ttf',
            bold: 'HanumanBold.ttf',
        },
        Arial: {
            normal: 'Arial.ttf',
            bold: 'Arial-Bold.ttf',
        },
        Garamon: {
            normal: 'Garamon.ttf',
            bold: 'Garamon-Bold.ttf',
        },
        Gilmer: {
            normal: 'Gilmer.ttf',
            bold: 'Gilmer-Bold.ttf'
        },
        RobotoItalic: {
            normal: 'Roboto-Italic.ttf',
            bold: 'Roboto-Italic.ttf'
        },
        RobotoRegular: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Regular.ttf'
        }
    };

}

pdfMake.styles = {
    title: {
        margin: [0,6,0,0],
        fontSize: 13,
        font: 'Garamon',
        bold: true,
        lineHeight: 1,
        alignment: 'center',
        fillColor: '#dddddd',
    },
    titleRoboto: {
        margin: [0, 6],
        fontSize: 13,
        font: 'RobotoRegular',
        bold: true,
        lineHeight: 1,
        alignment: 'center',
        fillColor: '#dddddd',
    },
    titleKh: {
        fontSize: 13,
        font: 'KhmerOs',
        bold: true,
        lineHeight: 1,
        alignment: 'center',
    },
    subTitle: {
        margin: [2, 0],
        fontSize: 9,
        font: 'KhmerOs',
        bold: true,
        lineHeight: 1,
        fillColor: '#dddddd',
    },
    subTitleHandOver: {
        margin: [2, 0],
        fontSize: 9,
        font: 'Arial',
        bold: true,
        lineHeight: 1,
        fillColor: '#6b6767',
    },
    subTitleKh: {
        margin: [4,2],
        fontSize: 8,
        font: 'KhmerOs',
        bold: true,
        lineHeight: 1,
        fillColor: '#dddddd',
    },
    subTitleKhLeave: {
        margin: [4,2],
        fontSize: 8,
        font: 'KhmerOs',
        normal: true,
        lineHeight: 1,
        fillColor: '#dddddd',
    },
    subTitleKh2:
        {
            margin: [4, 2],
            fontSize: 8,
            font: 'KhmerOs',
            bold: true,
            lineHeight: 1,
          //  fillColor: '#dddddd',
        },
    subTitleKhMail: {
        margin: [0,2,0,0],
        fontSize: 10,
        font: 'KhmerOs',
        bold: true,
        lineHeight: 1,
    },
    textKhBold: {
        margin: [1, 1],
        fontSize: 8,
        font: 'Hanuman',
        bold: true,
        lineHeight: 0.7,
    },
    textKhMail:{
        lineHeight:1,
        fontSize: 11,
        margin: [1, 1],
        font: 'Hanuman',
    },
    textKh: {
        margin: [1, 1],
        fontSize: 8,
        font: 'Hanuman',
        lineHeight: 1,
    },
    tHeaderKh: {
        fontSize: 8,
        font: 'Hanuman',
        lineHeight: 0.5,
        alignment: 'center',
        bold: true
    },
    tHeader: {
        fontSize: 8,
        bold: true,
        lineHeight: 1,
        fillColor: '#dddddd',
        alignment: 'center',
    },
    tHeaderLeave: {
        margin: [4,2],
        fontSize: 7,
        font: 'KhmerOs',
        normal: true,
        lineHeight: 1,
        color: "#fff",
        fillColor: '#2D669B',

    },
    tBody: {
        fontSize: 7.5,
        lineHeight: 1,
        alignment: 'center',
        font: 'Hanuman',
    },
    textEn: {
        fontSize: 8,
        lineHeight: 1,
        font: 'Garamon',
    },
    textEnBold: {
        fontSize: 8,
        lineHeight: 1,
        bold: true,
        font: 'Garamon',
    },
    label: {
        fontSize: 8,
        bold: true,
        lineHeight: 1,
        fillColor: '#dddddd',
    },
    value: {
        fontSize: 8,
        bold: false,
        lineHeight: 1,
        alignment: 'right'
    },
    'html-div': {
        fontSize: 9,
        lineHeight: 1.2
    },
    'html-b':{
        bold: true,
        fontSize: 7
    },
    'html-h3' : {
        fontSize: 6,
        bold: true
    },
    'html-table' : {
        width: 100
    },
    'html-p' : {
        margin: [0, 0, 0, 0],
    },
    'ql-align-center': {
        alignment: 'center'
    },
    'ql-align-right': {
        alignment: 'right'
    },
    'html-strong':{
        bold: true,
    },
};
export default pdfMake;
